// src/components/atomic-crm/providers/supabase/data-provider/lifecycleCallbacks.ts
import type { ContactNote, DealNote, Sale } from "../../../types";
import { uploadToBucket } from "./upload";
import { applyFullTextSearch } from "./transforms";
// ❌ Remove these imports:
// import { processCompanyLogo, processContactAvatar } from "./avatarProcessors";
import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";

export const lifecycleCallbacks = [
  {
    resource: "business_profile",
    beforeUpdate: async (params: any) => {
      if (params.data.logo && params.data.logo.rawFile instanceof File) {
        await uploadToBucket(params.data.logo);
      }
      return params;
    },
  },
  {
    resource: "sales",
    beforeSave: async (data: Sale, _: any, __: any) => {
      if (data.avatar) {
        await uploadToBucket(data.avatar);
      }
      return data;
    },
  },
  {
    resource: "companies",
    beforeGetList: async (params: any) => {
      return applyFullTextSearch(["search_text"])(params);
    },

  },
  {
    resource: "contacts",
    beforeGetList: async (params: any) => {
      return applyFullTextSearch(["search_text"])(params);
    },

  },
  {
    resource: "contacts_summary",
    beforeGetList: async (params: any) => {
      return applyFullTextSearch(["search_text"])(params);
    },
  },
  {
    resource: "deals",
    beforeGetList: async (params: any) => {
      return applyFullTextSearch(["name", "category", "description"])(params);
    },
  },
];
